import { educationPeriodDateSpread } from '@myap/ui-library/esm/date'
import { isEmpty } from '../../utils/common'

const mapStateToProps = state => {
  const { current, availableEducationPeriods } = state.settingsEducationPeriod
  const { academicYrStartDate = '', academicYrEndDate = '' } =
    !isEmpty(current) && !isEmpty(availableEducationPeriods) && availableEducationPeriods[current]

  return {
    date:
      academicYrStartDate && academicYrEndDate
        ? educationPeriodDateSpread(academicYrStartDate, academicYrEndDate)
        : null,
  }
}

export default connect(mapStateToProps)(({ date }) => {
  const academicYearSelectStatic = {
    float: 'left',
    marginRight: '20px',
    fontFamily: "'Roboto Slab Bold', sans-serif",
    fontWeight: 700,
    color: '#000',
  }

  return <div style={academicYearSelectStatic}>{date}</div>
})
